import { useEffect, useState } from "react";
import { api } from "services/api";

function useBrandBank() {
  const [isLoading, setIsLoading] = useState(true);
  const [bank, setBank] = useState({});

  useEffect(() => {
    async function getBank() {
      const { data: bankData } = await api.get("/brand-sms-bank");

      setBank(bankData);
      setIsLoading(false);
    }
    getBank();
  }, []);

  return {
    isLoading,
    bank,
  };
}

export default useBrandBank;
